import { useContext, useEffect, useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { UIContext } from 'Context/UI'
import { TableContext } from 'Context/Table'

import { toAbsoluteUrl } from '_metronic/helpers'

const MOCK_DATA = [
	{
		product_img: toAbsoluteUrl('/media/products/Box_img_1.png'),
		product_type: 'Child Product',
		product_num: '12345678',
		visibility: {
			favoriteAmount: 248,
			viewAmount: 1200,
		},
		stockQuantity: 360,
		sub: [
			{
				title: 'Sub Product 1',
				product_img: toAbsoluteUrl('/media/products/Box_img_2.png'),
				sku: '12345678',
				price: 9999,
				stockQuantity: 120,
				isActive: true,
			},
			{
				title: 'Sub Product 1',
				product_img: toAbsoluteUrl('/media/products/Box_img_3.png'),
				sku: '12345678',
				price: 9999,
				stockQuantity: 120,
				isActive: true,
			},
			{
				title: 'Sub Product 1',
				product_img: toAbsoluteUrl('/media/products/Box_img_4.png'),
				sku: '12345678',
				price: 2345,
				stockQuantity: 120,
				isActive: true,
			},
		],
		product_options: [
			{
				label: '10',
				unit: 'ใบ',
			},
			{
				label: '20',
				unit: 'ใบ',
			},
			{
				label: '99',
				unit: 'ใบ',
			},
		],
		product_warehouse: [
			{
				label: '99',
				unit: 'ใบ',
			},
			{
				label: '85',
				unit: 'ใบ',
			},
		],
		price: 120000,
		type: 'Parent Product',
		total_purchase: 120000,
		isActive: true,
		customer_img: toAbsoluteUrl('/media/avatars/300-1.jpg'),
		customer_name: 'Olivia Rhye',
		customer_num: '12345678',
	},
	{
		product_img: toAbsoluteUrl('/media/products/Box_img_2.png'),
		product_type: 'Child Product',
		product_num: '12345678',
		visibility: {
			favoriteAmount: 248,
			viewAmount: 1200,
		},
		stockQuantity: 360,
		product_options: [
			{
				label: '10',
				unit: 'ใบ',
			},
			{
				label: '20',
				unit: 'ใบ',
			},
			{
				label: '99',
				unit: 'ใบ',
			},
		],
		product_warehouse: [
			{
				label: '99',
				unit: 'ใบ',
			},
			{
				label: '85',
				unit: 'ใบ',
			},
		],
		price: 9999,
		type: 'Child Product',
		total_purchase: 33800,
		isActive: true,
		customer_img: toAbsoluteUrl('/media/avatars/300-1.jpg'),
		customer_name: 'Olivia Rhye',
		customer_num: '12345678',
	},
	{
		product_img: toAbsoluteUrl('/media/products/Box_img_3.png'),
		product_type: 'Child Product',
		product_num: '12345678',
		visibility: {
			favoriteAmount: 248,
			viewAmount: 1200,
		},
		stockQuantity: 360,
		sub: [
			{
				title: 'Sub Product 1',
				product_img: toAbsoluteUrl('/media/products/Box_img_2.png'),
				sku: '12345678',
				price: 9999,
				stockQuantity: 120,
				isActive: true,
			},
			{
				title: 'Sub Product 1',
				product_img: toAbsoluteUrl('/media/products/Box_img_3.png'),
				sku: '12345678',
				price: 9999,
				stockQuantity: 120,
				isActive: true,
			},
			{
				title: 'Sub Product 1',
				product_img: toAbsoluteUrl('/media/products/Box_img_4.png'),
				sku: '12345678',
				price: 2345,
				stockQuantity: 120,
				isActive: true,
			},
		],
		product_options: [
			{
				label: '10',
				unit: 'ใบ',
			},
			{
				label: '20',
				unit: 'ใบ',
			},
			{
				label: '99',
				unit: 'ใบ',
			},
		],
		product_warehouse: [
			{
				label: '99',
				unit: 'ใบ',
			},
			{
				label: '85',
				unit: 'ใบ',
			},
		],
		price: 9999,
		type: 'Parent Product',
		total_purchase: 16800,
		isActive: true,
		customer_img: toAbsoluteUrl('/media/avatars/300-1.jpg'),
		customer_name: 'Olivia Rhye',
		customer_num: '12345678',
	},
	{
		product_img: toAbsoluteUrl('/media/products/Box_img_4.png'),
		product_type: 'Child Product',
		product_num: '12345678',
		visibility: {
			favoriteAmount: 248,
			viewAmount: 1200,
		},
		stockQuantity: 360,
		product_options: [
			{
				label: '10',
				unit: 'ใบ',
			},
			{
				label: '20',
				unit: 'ใบ',
			},
			{
				label: '99',
				unit: 'ใบ',
			},
			{
				label: '99',
				unit: 'ใบ',
			},
		],
		product_warehouse: [
			{
				label: '99',
				unit: 'ใบ',
			},
			{
				label: '85',
				unit: 'ใบ',
			},
		],
		price: 2345,
		type: 'Child Product',
		total_purchase: 120000,
		isActive: true,
		customer_img: toAbsoluteUrl('/media/avatars/300-1.jpg'),
		customer_name: 'Olivia Rhye',
		customer_num: '12345678',
	},
	{
		product_img: toAbsoluteUrl('/media/products/Box_img_5.png'),
		product_type: 'Child Product',
		product_num: '12345678',
		visibility: {
			favoriteAmount: 248,
			viewAmount: 1200,
		},
		stockQuantity: 360,
		product_options: [
			{
				label: '10',
				unit: 'ใบ',
			},
			{
				label: '20',
				unit: 'ใบ',
			},
			{
				label: '99',
				unit: 'ใบ',
			},
		],
		product_warehouse: [
			{
				label: '99',
				unit: 'ใบ',
			},
			{
				label: '85',
				unit: 'ใบ',
			},
		],
		price: 888,
		type: 'Child Product',
		total_purchase: 120000,
		isActive: true,
		customer_img: toAbsoluteUrl('/media/avatars/300-1.jpg'),
		customer_name: 'Olivia Rhye',
		customer_num: '12345678',
	},
]

const FILTERS: {
	label: string
	isActive: boolean
	number?: number
	numberColor?: 'green' | 'white' | 'grey'
}[] = [
	{
		label: 'ทั้งหมด',
		isActive: false,
		number: 132,
		numberColor: 'green',
	},
	{
		label: 'ขายอยู่',
		isActive: false,
		number: 1,
		numberColor: 'grey',
	},
	{
		label: 'หมด',
		isActive: false,
	},
	{
		label: 'รอตรวจสอบ',
		isActive: true,
		number: 10,
		numberColor: 'white',
	},
	{
		label: 'ละเมิด',
		isActive: false,
		number: 35,
		numberColor: 'green',
	},
	{
		label: 'ไม่แสดง',
		isActive: false,
		number: 8,
		numberColor: 'grey',
	},
]

const ViewModel = () => {
	const navigate = useNavigate()
	const { setCustomContentToolbar, setShowContentToolbar } = useContext(UIContext)
	const { updateLoading } = useContext(TableContext)

	const [viewType, setViewType] = useState<'table' | 'box'>('table')
	const data = useMemo(() => {
		if (viewType === 'box') {
			return MOCK_DATA
		} else {
			return MOCK_DATA.reduce((acc: any[], item) => {
				if (item?.sub && (item?.sub ?? []).length > 0) {
					acc.push(item)
					item.sub.forEach((subItem: any) => {
						acc.push({
							isSub: true,
							product_type: subItem.title,
							product_num: subItem.sku,
							product_img: subItem.product_img,
							price: subItem.price,
							stockQuantity: subItem.stockQuantity,
							isActive: subItem.isActive,
						})
					})
				} else {
					acc.push(item)
				}

				return acc
			}, [])
		}
	}, [viewType])

	const setupTable = () => {
		updateLoading(false)
	}

	const newProduct = () => {
		navigate('/products/new')
	}

	const changeViewType = (type: 'table' | 'box') => {
		setViewType(type)
	}

	useEffect(() => {
		setShowContentToolbar(false)
		setCustomContentToolbar(null)

		return () => {
			setShowContentToolbar(true)
			setCustomContentToolbar(null)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	useEffect(() => {
		setupTable()

		// eslint-disable-next-line
	}, [])

	return {
		filters: FILTERS,
		data,
		viewType,
		changeViewType,
		newProduct,
	}
}

export default ViewModel
